import type {
  DataAccessConfigPayload,
  DataAccessListPayload,
  DataAccessUpdatePayload,
} from "@/types";
import httpClient from ".";
import { API_ENDPOINTS } from "./endpoints";

export const fetchDataAccessConfig = async (
  dataAccessConfigPayload: DataAccessConfigPayload,
) => {
  const url = API_ENDPOINTS.DATA_ACCESS.CONFIG;
  const { token, ...payload } = dataAccessConfigPayload;
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
      "Accept-Version": "1.0",
    },
  };
  return httpClient
    .post(url, payload, config)
    .then((response) => response.data);
};

export const fetchDataAccessList = async (
  dataAccessListPayload: DataAccessListPayload,
) => {
  const url = `/${dataAccessListPayload.memberId}${API_ENDPOINTS.DATA_ACCESS.AUTHORIZATION_ACCESS}`;
  const { token } = dataAccessListPayload;
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
      "Accept-Version": "1.0",
      GroupId: dataAccessListPayload?.groupId,
    },
  };
  return httpClient.get(url, config).then((response) => response.data);
};

export const updateDataAccess = async (
  updateDataAccessPayload: DataAccessUpdatePayload,
) => {
  const { token, memberId, ...payload } = updateDataAccessPayload;
  const url = `/${memberId}${API_ENDPOINTS.DATA_ACCESS.AUTHORIZATION_ACCESS}`;
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
      "Accept-Version": "1.0",
    },
  };
  return httpClient
    .post(url, payload, config)
    .then((response) => response.data);
};
